import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const UnpublishConfirmationPopup = ({ onConfirm, onCancel, chatName, open }) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="xs"
            fullWidth
            sx={{
                "& .MuiDialog-paper": { borderRadius: 2, p: 2 }, // Rounded corners & padding
            }}
        >

            <DialogContent>
                <Typography variant="body1" sx={{ textAlign: "center", mb: 2 }}>
                    Do you really want to unpublish "{chatName}"?
                </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "end", gap: 2 }}>
                <Button
                    variant="outlined"
                    onClick={onCancel}
                    sx={{ minWidth: 120 }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    sx={{
                        minWidth: 120, color: "black", backgroundColor: "#cce28b",// Ensures contrast
                        "&:hover": { backgroundColor: "#cce28b" },
                    }}
                >
                    Unpublish
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnpublishConfirmationPopup;
